/**
 * @description: 配料消耗明细报表
 * @author: lyr
*/
<template>
    <div class="sr-pxm-report">
        <div class="list" v-show="!showBillDetail">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请输入包厢号">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账单号">
                    <el-input placeholder="请输入账单号" clearable v-model="list_form.bill_no"></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input placeholder="请选择商品类型" v-model="ingredients_goods_type_str" readonly @click.native="openGoodsTypePop"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input placeholder="请输入配料名称" clearable v-model="list_form.ingredients_goods_name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList(1)">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">进货价合计金额：{{total_buying_price}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="create_time" label="下单时间"></el-table-column>
                <el-table-column prop="ingredients_goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="ingredients_goods_name" label="名称"></el-table-column>
                <el-table-column prop="ingredients_goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="quantity" label="消耗数量"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="total_buying_price" label="进货价合计"></el-table-column>
                <el-table-column prop="goods_name" label="所属商品"></el-table-column>
                <el-table-column prop="bill_no" label="账单号"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="toBillDetail(scope.row.bill_no)">账单详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 商品类型选择 -->
        <div class="goods-type-pop" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.ingredients_goods_type" @change="handleCheckGoodsTypeChange">
                    <el-checkbox v-for="item in goods_type" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 账单详情 -->
        <div class="bill-det" v-show="showBillDetail">
            <billDetail ref="bill_det" @backBdwPre="showBillDetail = false"></billDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_list: [],
                goods_type: [], // 商品类型列表
                checkAllGoodsType: false,
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    room_id: '',
                    bill_no: '', 
                    ingredients_goods_type: [],
                    ingredients_goods_name: '',
                },
				list_table: [],
				list_page: 1,
                list_total: 0,
                total_buying_price: 0,
                showBillDetail: false,
            }
        },
        components: {
            "billDetail": billDetail,
        },
        computed: {
            ingredients_goods_type_str() {
                if (this.list_form.ingredients_goods_type.length == 0) {
                    return ''
                }else if(this.list_form.ingredients_goods_type.length == this.goods_type.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.ingredients_goods_type.forEach(v => {
                        this.goods_type.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getGoodsType()
                this.getRoom(this.list_form.shop_id)
                this.setShopDefaultTime(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },

            // 点击“账单详情”
            toBillDetail(bill_no) {
                this.$refs.bill_det.getBdwDetail(bill_no)
                this.showBillDetail = true
            },

            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取商品类型列表
            getGoodsType: function() {
                let _this = this;
               
                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type = res.data.response.result.data
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
                const _this = this;

                _this.loading = true;
                _this.list_page = page;
                Vue.axios.post('FinanceReport2/goodsIngredientsList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "room_id": _this.list_form.room_id, 
                            "bill_no": _this.list_form.bill_no,
                            "ingredients_goods_type": _this.list_form.ingredients_goods_type, 
                            "ingredients_goods_name": _this.list_form.ingredients_goods_name, 
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.list_total = Number(res.data.response.result.total)
                            _this.total_buying_price = res.data.response.result.total_buying_price
                        }
                        _this.list_table = res.data.response.result.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            changeShop(val) {
                this.list_form.shop_id = val
                this.list_form.room_id = ''
                this.list_form.ingredients_goods_type = []
                if (!!val) {
                    this.getGoodsType()
                    this.getRoom(val)
                    this.setShopDefaultTime(val)
                    this.getList(1);
                }
            },

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type_ids = _this.list_form.ingredients_goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.ingredients_goods_type = c_goods_type_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.ingredients_goods_type = c_goods_type_ids
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.list_form.ingredients_goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.goods_type.forEach(item => {
                        this.list_form.ingredients_goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.goods_type.length
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/exportGoodsIngredientsList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&room_id=" + this.list_form.room_id +
                    "&bill_no=" + this.list_form.bill_no +
                    "&ingredients_goods_type=" + this.list_form.ingredients_goods_type +
                    "&ingredients_goods_name=" + this.list_form.ingredients_goods_name; 
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }

    .goods-type-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
</style>